(function () {
  'use strict';

  var EVENT_PARAMETER = 'event';
  var SAFE_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
  var SAFE_PARAMETER_NAME_PATTERN = /^[A-Za-z0-9_.-]{1,64}$/;
  var SENSITIVE_PARAMETER_NAME_PATTERN = /(auth|cookie|password|secret|session|signature|token)/i;
  var CONTROL_CHARACTER_PATTERN = /[\u0000-\u001f\u007f]/;

  function toSafeEventSlug(value) {
    var slug = typeof value === 'string' ? value.trim().toLowerCase() : '';
    return SAFE_SLUG_PATTERN.test(slug) ? slug : null;
  }

  function isSafeQueryParameter(name, value) {
    return SAFE_PARAMETER_NAME_PATTERN.test(name)
      && !SENSITIVE_PARAMETER_NAME_PATTERN.test(name)
      && typeof value === 'string'
      && value.length <= 512
      && !CONTROL_CHARACTER_PATTERN.test(value);
  }

  function buildSafePageUrl(slug) {
    var source = new URL(window.location.href);
    var safeUrl = new URL(source.pathname, source.origin);

    source.searchParams.forEach(function (value, name) {
      if (name === EVENT_PARAMETER || !isSafeQueryParameter(name, value)) return;
      safeUrl.searchParams.append(name, value);
    });

    if (slug) {
      safeUrl.searchParams.set(EVENT_PARAMETER, slug);
      safeUrl.hash = 'event-' + slug;
    }

    return safeUrl;
  }

  function readRequestedSlug() {
    var values = new URLSearchParams(window.location.search).getAll(EVENT_PARAMETER);
    if (values.length !== 1) return null;
    return toSafeEventSlug(values[0]);
  }

  function focusSelectedEvent(shell, item) {
    if (shell.__fhEventDetailFocused) return;
    shell.__fhEventDetailFocused = true;

    if (!item.hasAttribute('tabindex')) item.setAttribute('tabindex', '-1');
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (item.scrollIntoView) item.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });

    if (!item.focus) return;
    try {
      item.focus({ preventScroll: true });
    } catch (error) {
      item.focus();
    }
  }

  function buildDetailEndpoint(root, slug) {
    var base = root.getAttribute('data-fh-events-default-request-endpoint') || root.getAttribute('data-endpoint') || '';
    base = base.trim().replace(/\/+$/, '');
    return base && slug ? base + '/' + encodeURIComponent(slug) : '';
  }

  function restoreAllEventsMode(shell, root, state) {
    var allEventsUrl = buildSafePageUrl(null);
    var allEventsWrap = shell.querySelector('[data-fh-event-detail-all-events]');

    window.history.replaceState(window.history.state, '', allEventsUrl.pathname + allEventsUrl.search);
    shell.setAttribute('data-fh-event-detail-mode', 'all');
    shell.setAttribute('data-fh-event-detail-state', state || 'idle');
    shell.removeAttribute('data-fh-event-detail-slug');
    root.setAttribute('data-layout', root.getAttribute('data-fh-events-default-layout') || 'sidebar');
    root.setAttribute('data-limit', root.getAttribute('data-fh-events-default-limit') || '4');
    root.setAttribute('data-show-description', root.getAttribute('data-fh-events-default-show-description') || 'false');
    root.setAttribute('data-fh-events-display-mode', 'catalogue');
    root.setAttribute('data-fh-events-response-mode', 'list');
    root.setAttribute(
      'data-events-request-endpoint',
      root.getAttribute('data-fh-events-default-request-endpoint') || root.getAttribute('data-endpoint') || ''
    );
    if (allEventsWrap) allEventsWrap.hidden = true;

    if (state === 'not-found' && !shell.__fhEventDetailFallbackReloaded) {
      shell.__fhEventDetailFallbackReloaded = true;
      root.dispatchEvent(new CustomEvent('fh:events:reload'));
    }
  }

  function applyDetailSelection(shell, root, slug) {
    if (shell.getAttribute('data-fh-event-detail-mode') !== 'detail') return;
    var items = root.querySelectorAll('.fh-events__item[id^="event-"]');
    if (!items.length) {
      if (root.querySelector('[data-fh-events-state="not-found"], [data-fh-events-state="empty"]')) {
        restoreAllEventsMode(shell, root, 'not-found');
      }
      return;
    }

    var selected = root.querySelector('#event-' + slug);
    items.forEach(function (item) {
      if (item === selected) {
        item.setAttribute('data-fh-event-detail-selected', 'true');
      } else {
        item.removeAttribute('data-fh-event-detail-selected');
      }
    });

    if (!selected) {
      restoreAllEventsMode(shell, root, 'not-found');
      return;
    }

    shell.setAttribute('data-fh-event-detail-state', 'ready');
    focusSelectedEvent(shell, selected);
  }

  function initShell(shell) {
    if (!shell || shell.__fhEventDetailModeInitialized) return;
    shell.__fhEventDetailModeInitialized = true;

    var root = shell.querySelector('[data-fh-events-detail-root]');
    if (!root) return;

    var eventValues = new URLSearchParams(window.location.search).getAll(EVENT_PARAMETER);
    var slug = readRequestedSlug();
    if (!slug) {
      shell.setAttribute('data-fh-event-detail-mode', 'all');
      shell.setAttribute('data-fh-event-detail-state', eventValues.length ? 'invalid' : 'idle');
      return;
    }

    var detailUrl = buildSafePageUrl(slug);
    var allEventsUrl = buildSafePageUrl(null);
    var allEventsWrap = shell.querySelector('[data-fh-event-detail-all-events]');
    var allEventsLink = shell.querySelector('[data-fh-event-detail-all-events-link]');

    window.history.replaceState(window.history.state, '', detailUrl.pathname + detailUrl.search + detailUrl.hash);
    shell.setAttribute('data-fh-event-detail-mode', 'detail');
    shell.setAttribute('data-fh-event-detail-state', 'loading');
    shell.setAttribute('data-fh-event-detail-slug', slug);
    root.setAttribute('data-layout', 'list');
    root.setAttribute('data-limit', root.getAttribute('data-fh-events-detail-limit') || '20');
    root.setAttribute('data-show-description', 'true');
    root.setAttribute('data-fh-events-display-mode', 'detail');
    root.setAttribute('data-fh-events-response-mode', 'detail');
    root.setAttribute('data-events-request-endpoint', buildDetailEndpoint(root, slug));

    if (allEventsLink) allEventsLink.href = allEventsUrl.pathname + allEventsUrl.search;
    if (allEventsWrap) allEventsWrap.hidden = false;

    root.addEventListener('fh:events:loaded', function () {
      applyDetailSelection(shell, root, slug);
    });

    var observer = new MutationObserver(function () {
      applyDetailSelection(shell, root, slug);
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var shells = root.querySelectorAll('[data-fh-event-detail-shell]');
    shells.forEach(initShell);

    if (root.matches && root.matches('[data-fh-event-detail-shell]')) initShell(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event && event.target);
  });
})();
